export default {
  // 获取当天活动
  activityQueryDay: { url: '/v1/m/activity/queryDay' },
  // 查看动作
  activityUpdateDay: { url: '/v1/m/activity/updateDay' },
  // 查看用户详情
  queryUserDetail: { url: '/v1/tenant/queryUserDetail' },
};
